// A step whose logic is JavaScript written by Ledgerate AI. It is registered
// so the trail and viewer can label it, but it never runs here: code steps
// run in the sandbox (engine/code/run.js).
import { defineStep } from "../registry";

export const codeStep = defineStep({
  type: "code",
  label: "Code",
  category: "Code",
  description: "JavaScript written by Ledgerate AI, run on your device in an isolated sandbox.",
  inputs: { min: 1, max: 10 },
  params: {},
  run: () => {
    throw new Error("Code steps run in the sandbox (engine/code/run.js)");
  },
});
